import React from "react";

import "./index.scss";

const BadgeLabel = props => {
  const { badgeDescription, badgeText, customClass, error, labelColor, badgeDisable } = props;

  return (
    <div className={`badge-container ${customClass}`}>
      {badgeDescription && <div className={labelColor ? labelColor : "badge-label"}>{badgeDescription}</div>}
      {badgeText !== null && badgeText !== undefined && (
        <span className={error ? "badge-error" : badgeDisable ? "badge-disable" : !badgeDescription ? "badge-text__noMargin" : ""}>{badgeText}</span>
      )}
    </div>
  );
};

export default BadgeLabel;
